<div id='transfer-text'>{{trans('systems.labels.transferToCompanyInfo')}}</div>
<div class="white_round padding_sides16">
    <app-text-edit id='transfer-alias' [value]='companyAlias' (enterClicked)="onConfirm()" (valueChanged)="companyAlias = $event">{{trans('companies.labels.alias')}}</app-text-edit>
</div>
